import React, { useEffect } from 'react';
import InputField from '../../Forms/Input/InputField';
import { ProductFormValues } from '../../../types/product/ProductFormValues';
import { useProduct } from '../../../hooks/useProduct';

import { useProductSizes } from '../../../hooks/product/useProductSizes';
import { useProductColors } from '../../../hooks/product/useProductColors';

import SimpleSearchSelect from '../../Forms/Input/SimpleSearchSelect';
import QuickAddProductSize from '../../QuickAdd/ProductSize/QuickAddProductSize';
import QuickAddProductColor from '../../QuickAdd/ProductColor/QuickAddProductColor';

interface Props {
  form: ProductFormValues;
  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductAttributesVariant: React.FC<Props> = ({ form, onChange }) => {
  const { formErrors } = useProduct();

  // ============================
  // SIZES HOOK
  // ============================
  const {
    handlerAddProductSize,
    productSizesDropdown,
    fetchProductSizesDropdown,
    searchProductSizesDropdown,
  } = useProductSizes();

  // ============================
  // COLORS HOOK
  // ============================
  const {
    handlerAddProductColor,
    productColorsDropdown,
    fetchProductColorsDropdown,
    searchProductColorsDropdown,
  } = useProductColors();

  // load dropdowns
  useEffect(() => {
    fetchProductSizesDropdown();
    fetchProductColorsDropdown();
  }, []);

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

      {/* ================= COLOR ================= */}
      <div className="col-span-1 md:col-span-2">
        <QuickAddProductColor
          onColorCreated={handlerAddProductColor}
          onReload={fetchProductColorsDropdown}
        />

        <SimpleSearchSelect
          label="Color"
          name="colorId"
          iconKey="tag"
          options={productColorsDropdown}
          selectedValue={form.colorId}
          onSelect={(selected) => onChange('colorId', selected.id)}
          onSearch={(value) => searchProductColorsDropdown(value)}
          searchPlaceholder="Buscar color…"
          error={formErrors.colorId}
        />
      </div>

      {/* ================= VARIANTE ================= */}
      <InputField
        label="Variante"
        name="variant"
        type="text"
        iconKey="edit"
        value={form.variant ?? ''}
        onChange={(e) => onChange('variant', e.target.value)}
        placeholder="Ej: Limited Edition"
        error={formErrors.variant}
      />

      {/* ================= TALLA ================= */}
      <div className="col-span-1 md:col-span-2">
        <QuickAddProductSize
          onSizeCreated={handlerAddProductSize}
          onReload={fetchProductSizesDropdown}
        />

        <SimpleSearchSelect
          label="Talla"
          name="sizeId"
          iconKey="hash"
          options={productSizesDropdown}
          selectedValue={form.sizeId}
          onSelect={(selected) => onChange('sizeId', selected.id)}
          onSearch={(value) => searchProductSizesDropdown(value)}
          searchPlaceholder="Buscar talla…"
          error={formErrors.sizeId}
        />
      </div>
    </div>
  );
};

export default ProductAttributesVariant;
